import { accountAnalyticTooltipHandler } from "./accountAnalyticTooltipHandler";

const useAccountAnalyticChart = (data, filter) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: false,
        external: accountAnalyticTooltipHandler,
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          usePointStyle: true,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Amount in $",
        },
      },

      x: {
        ticks: {
          callback(val, _index) {
            let label = this.getLabelForValue(val);

            return filter === "current_year" ? label : "";
          },
        },
      },
    },
  };

  const chartData = {
    labels: data?.labels,
    datasets: [
      {
        label: "Expected",
        expected: data?.expected?.map((expected) => expected),
        data:
          data?.expected?.length > 0
            ? data?.expected?.map(
                (expected) =>
                  expected
                    ?.filter((item) => item?.title === "Expected")
                    ?.map((item) => item?.amount)?.[0]
              )
            : [],
        borderColor: "#5489D8",
        backgroundColor: "#5489D8",
      },
      {
        label: "Actual",
        actual: data?.actual?.map((actual) => actual),
        data:
          data?.actual?.length > 0
            ? data?.actual?.map(
                (actual) =>
                  actual
                    ?.filter((item) => item?.title === "Actual")
                    ?.map((item) => item?.amount)?.[0]
              )
            : [],
        borderColor: "#FFBB37",
        backgroundColor: "#FFBB37",
      },
    ],
  };

  return { options, chartData };
};

export default useAccountAnalyticChart;
